<template>
  <div id="postalCodeVue" v-if="askData">
    <LanguageSelector focus="#consigneePostalCode" />
    <div id="postalCodeForm" v-if="$props.token != null">
      <validation-observer ref="observer" tag="form" v-slot="{ invalid }">
        <div id="postalCodeContainer" class="fieldConteiner">
          <validation-provider
            rules="required"
            v-slot="{
              classes
            }"
          >
            <input
              id="consigneePostalCode"
              type="text"
              v-model="postalCode"
              name="Código Postal"
              :class="classes"
              autocomplete="off"
              autofocus
            />
            <label for="consigneePostalCode">{{ $t("postalCode") }}</label>
          </validation-provider>
        </div>
        <button
          id="btnSearch"
          class="btn"
          :disabled="invalid"
          @click="buscarExpedicion"
        >
          {{ $t("search") }}
        </button>
      </validation-observer>
    </div>
    <div v-else>
      <LanguageSelector />
      <h1>
        {{ $t("token.notFound") }}
      </h1>
    </div>
  </div>
</template>

<style scoped src="./css/postalCode.css"></style>

<script>
//Include validations rules
import { extend } from "vee-validate";
import LanguageSelector from "@/components/LanguageSelector.vue";

import http from "@/http-commons";

const CONTEXT = "/public/expeditions";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true
});

export default {
  name: "postalCode",
  components: {
    LanguageSelector
  },
  props: {
    token: {
      type: String,
      required: true
    },
    uuid: {
      type: String,
      required: false
    },
    lang: {
      type: String,
      required: false
    },
    tpvConfirm: {
      type: String,
      required: false
    }
  },
  data: () => ({
    askData: false,
    postalCode: "",
    tenant: "default"
  }),
  methods: {
    buscarExpedicion() {
      this.$router.push({
        name: "expeditions_" + this.tenant,
        params: {
          token: this.$props.token,
          consigneePostalCode: this.postalCode,
          organization: this.tenant
        },
        query: {
          uuid: this.$props.uuid,
          lang: this.$props.lang,
          tpvConfirm: this.$props.tpvConfirm
        }
      });
    },
    searchTenantAuth(token) {
      var tokenMatch;
      try {
        // Validate token MD5
        let tokenRegex = new RegExp("^\\d{0,10}[A-Z]{4}");
        tokenMatch = tokenRegex.exec(token).toString();
        var tokenMD5 = require("crypto")
          .createHash("md5")
          .update(tokenMatch.toString())
          .digest("hex");
        tokenMD5 = tokenMD5.substring(0, 16 - tokenMatch.length).toUpperCase();
        tokenMatch = tokenMatch + tokenMD5;
      } catch (ex) {
        console.error(ex);
      }

      if (tokenMatch === token) {
        http
          .get(CONTEXT + "/tenantAuthorization/" + token)
          .then(response => {
            this.tenant = response.data.tenant;
            if (response.data && response.data.consigneePostalCode) {
              this.postalCode = response.data.consigneePostalCode;
              //Here, we also have the tenant in response.data.tenant (for future use)
              this.buscarExpedicion();
            } else {
              this.askData = true;
            }
          })
          .catch(e => {
            console.log(this.$t("shipment.notFound"), e);
          });
      }
    }
  },
  beforeMount() {
    this.searchTenantAuth(this.$props.token);
  }
};
</script>
